import AppLoader from '@/components/AppLoader';
import { useBookingPlannerController } from './booking-planner.controller';
import { BookingPlannerSuccessView } from './components/booking-planner-success.view';

export function BookingPlannerView() {
	const { calendarQuery, calendarEventsQuery } = useBookingPlannerController();

	if (!calendarEventsQuery.data || !calendarQuery.data) {
		return <AppLoader />;
	}

	return <BookingPlannerSuccessView calendars={[calendarQuery.data]} events={calendarEventsQuery.data.items} />;
}
